import { apiRequest } from "./request";
import { CreditTransactionAnalytics } from "@/pages/Admin/Stats/StatsPage";
import { IUserJob, Resume, User } from "@/types";
import { ICreditTransaction } from "@/types/creditTransaction";

export interface StatsRequest {
    startDate: string | null;
    endDate: string | null;
    userId: string;
}

const getAllResumes = (params: StatsRequest) =>
    apiRequest<Resume[]>(`/stats/resumes`, "GET", params);

const getAllUsers = (params: StatsRequest) =>
    apiRequest<User[]>(`/stats/users`, "GET", params);

const getCreditTransactionAnalytics = (
    params: StatsRequest,
): Promise<{
    analytics: CreditTransactionAnalytics;
    transactions: ICreditTransaction[];
}> => apiRequest(`/stats/transactions`, "GET", params);

const getResumesPerUser = (params: StatsRequest) =>
    apiRequest(`/stats/resumes-per-user`, "GET", params);

const getDocumentLimitStats = (params: StatsRequest) =>
    apiRequest(`/stats/document-limit`, "GET", params);

const getAiFeedbackStats = (params: StatsRequest) =>
    apiRequest(`/stats/ai-feedback`, "GET", params);

const getCreditSpendUserProfileStats = (params: StatsRequest) =>
    apiRequest(`/stats/profiles`, "GET", params);

const getAllUserJobs = (params: StatsRequest) =>
    apiRequest<{ results: IUserJob[] }>(`/stats/user-jobs`, "GET", params);

export default {
    getAllResumes,
    getAllUsers,
    getCreditTransactionAnalytics,
    getDocumentLimitStats,
    getResumesPerUser,
    getAiFeedbackStats,
    getCreditSpendUserProfileStats,
    getAllUserJobs,
};
